
import { hiddenErrorsService } from "@/services/hiddenErrorsService";
import { ResourceResult } from "@/services/resourceWatcherService";
import { getPathname, isErrorStatusCode } from "@/utils";
import { ResourceType } from "@/utils/watcher";
import { computed, defineComponent, toRefs } from "vue";
import ResourceAnchor from "./ResourceAnchor.vue";

export default defineComponent({
	components: { ResourceAnchor },
	props: {
		result: {
			type: Object as () => ResourceResult,
			required: true,
		},
		showFullDomain: {
			type: Boolean,
			default: false,
		},
		columnsBitmask: {
			type: Array as () => boolean[],
			default: null,
		},
	},
	setup(props) {
		const { result, showFullDomain, columnsBitmask } = toRefs(props);

		const urlToDisplayableUrl = (url: string) =>
			showFullDomain.value ? url : getPathname(url);

		const sitemapPathname = computed(() =>
			showFullDomain.value
				? result.value.sitemap
				: getPathname(result.value.sitemap)
		);
		const resourceUrl = computed(() =>
			urlToDisplayableUrl(result.value.url)
		);

		const firstSource = computed(() => result.value.sources[0]);
		const extraSourcesCount = computed(
			() => result.value.sources.length - 1
		);

		const isError = isErrorStatusCode(result.value.status);
		const statusClass = isError ? "table-danger" : "table-success";

		let durationClass = "";
		if (1000 <= result.value.durationMS && result.value.durationMS < 1500) {
			durationClass = "table-warning";
		} else if (1500 <= result.value.durationMS) {
			durationClass = "table-danger";
		}

		const { hiddenErrors, hideError } = hiddenErrorsService;
		const isHidden = computed(
			() => !!hiddenErrors.value.has(result.value.url)
		);

		const hasAnchors = computed(() => !!result.value.sources[0].anchor);

		return {
			sitemapPathname,
			resourceUrl,

			firstSource,
			extraSourcesCount,

			isColumnEnabled: columnsBitmask,
			isError,
			statusClass,
			durationClass,

			urlToDisplayableUrl,

			isHidden,
			hideError,

			hasAnchors,

			ResourceType,
		};
	},
});
